import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import Image from 'next/legacy/image'
import React, { PropsWithChildren, useMemo } from 'react'
import {
    StyledCarouselImageWrapper,
    StyledImage,
    StyledImageContainer,
    StyledNewsCardDoubleTriangle,
    StyledNewsCardTriangle,
} from './styledCarouselImage'

// Image
export type CarouselImageProps = React.ComponentProps<typeof StyledImage> & {
  src?: string
}

export const CarouselImage: React.FC<PropsWithChildren<CarouselImageProps>> = ({ src, ...props }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
  const isTablet = useMediaQuery(theme.breakpoints.down('sm'))
  const svgDim = useMemo(() => {
    if (isMobile) {
      return {
        doubleTriangle: {
          width: 64,
          height: 76,
        },
        triangle: {
          width: 72,
          height: 67,
        },
      }
    }

    if (isTablet) {
      return {
        doubleTriangle: {
          width: 80,
          height: 95,
        },
        triangle: {
          width: 72,
          height: 67,
        },
      }
    }

    return {
      doubleTriangle: {
        width: 142,
        height: 170,
      },
      triangle: {
        width: 90,
        height: 85,
      },
    }
  }, [isMobile, isTablet])

  return (
    <StyledCarouselImageWrapper item xs={12} sm={12}>
      <StyledImageContainer>
        <StyledImage src={src} layout={'fill'} {...props} />
        <StyledNewsCardTriangle iconCode={'traingle'} width={svgDim.triangle.width} height={svgDim.triangle.height} />
        <StyledNewsCardDoubleTriangle>
          <Image src={'/images/double_triangle.svg'} layout="fill" alt={''} />
        </StyledNewsCardDoubleTriangle>
      </StyledImageContainer>
    </StyledCarouselImageWrapper>
  )
}
